import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import * as moment from 'jalali-moment';
import { CompleteFormService } from 'src/app/services/api/complete-form.service';
import { CriteriaService, GlobalService } from 'src/app/services/index.service';


@Component({
  selector: 'app-horizontal-bar',
  templateUrl: './horizontal-bar.component.html',
  styleUrls: ['./horizontal-bar.component.scss']
})
export class HorizontalBarComponent implements OnInit {
  @Input() horizontalChart:any;
  @Input() user:any;
  @Input() exam:any;
  @Input() shortShow:boolean = false;
  countCompleted = false;
  chartList:any;
  public options = {
    separator: '.',
    duration: 2,
    useEasing:true,
    suffix: '%',
    numerals: ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'],
  };
  viewInited:boolean = false;
  constructor(
    private renderer: Renderer2, 
    private el: ElementRef,
    private completeForm:CompleteFormService,
    private globalService:GlobalService,
    private criteriaService:CriteriaService
  ) { }

  ngOnInit(): void {
    // console.log('before : ',this.horizontalChart)
    this.chartList = Object.values(this.horizontalChart)
    this.chartList.pop()
    this.chartList.pop()
    this.chartList.pop()
    this.chartList.pop()
    this.chartList.pop()
    if(this.horizontalChart.sortable){
      this.sortChart()
    }
    this.criteriaService.CanExit = true
    setTimeout(() => {
      this.fixed()
    }, 3000);
  }
  getTimePerMinutes(time:string){
    return this.globalService.convertTime(time)
  }
  getBackButton(){
    return this.completeForm.getBackButton()
  }
  returnLastTakeExamDay(data:any){
    let NDay:any;
    let lastExamTime = Date.parse(moment(data,'YYYY/M/D HH:mm:ss').format('YYYY/M/D HH:mm:ss'))
    let newDateTime = Date.parse(moment(new Date(),'YYYY/M/D HH:mm:ss').format('YYYY/M/D HH:mm:ss'))
    let n_diff = (newDateTime-lastExamTime)/(1000 * 60 * 60 * 24)
    if(n_diff<=1){
      NDay = 'امروز'
    }else if(n_diff > 1 && n_diff < 1.5){
      NDay = 'دیروز'
    }else{
      let round = Math.ceil(n_diff)
      NDay = `${round} روز قبل` 
    }
    return NDay
  }
  scrollToTop(){
    this.globalService.scrollTop()
    this.completeForm.setBackButton(null)
  }
  fixed() {
    this.countCompleted = true;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.viewInited = true;
    });
  }
  getCharType(){
    let charType:string[] = [];
    
    this.chartList.forEach((item:any) => {if(item.show) charType.push(item.show)})
    return charType.join('')
  }
  setWidth(chart:any){
    return chart.is_fliped ? chart.score : 100 - chart.score
  }
  sortChart(){
    let sortedProducts = this.chartList.sort(
      (p1:any, p2:any) => (p1.score < p2.score) ? 1 : (p1.score > p2.score) ? -1 : 0);
    this.chartList = sortedProducts 
  }
}